import Link from 'next/link'
import styles from './SearchTagList.module.scss'
import { CSSProperties } from 'react'

interface SearchTagListProps {
  currentCategory?: string
}

const SearchTagList: React.FC<SearchTagListProps> = ({ currentCategory }) => {
  const isDisabled: CSSProperties = currentCategory ? { pointerEvents: 'none' } : {}

  const categoryGroups = [
    [
      { name: 'アプリケーション開発', link: '/cases/application-development' },
      { name: 'DevOps構築', link: '/cases/devops' },
      { name: 'クラウド導入支援', link: '/cases/cloud' },
      { name: 'デザインシステム構築', link: '/cases/design-system' },
      { name: 'UI/UXデザイン', link: '/cases/uiuxdesign' },
      { name: 'プロダクトマネジメント', link: '/cases/product-management' },
    ],
    [
      { name: '生成AI導入', link: '/cases/ai' },
      { name: '特徴量エンジニアリングと生成AI', link: '/cases/feature-engineering' },
      { name: 'xR/メタバース導入', link: '/cases/xr' },
    ],
    [
      { name: '事業戦略策定', link: '/cases/strategy' },
      { name: 'DX戦略策定', link: '/cases/dx' },
      { name: '組織開発・人材育成', link: '/cases/hip' },
    ],
    [
      { name: 'flamingo', link: '/cases/flamingo' },
      { name: 'DRESSX', link: '/cases/dressx' },
    ],
  ]

  const industryCategories = [
    { name: 'IT/情報/通信', link: '/cases/telecommunications', color: 'gray' },
    { name: 'メーカー/製造/建設', link: '/cases/manufacturing', color: 'gray' },
    { name: '銀行/保険/証券', link: '/cases/finance', color: 'gray' },
    { name: '小売/流通/物流', link: '/cases/retail', color: 'gray' },
    { name: 'その他', link: '/cases/other', color: 'gray' },
  ]

  const renderCategoryItem = (category: { name: string; link: string; color?: string }) => {
    const isActive = currentCategory === category.name
    const isGray = category.color === 'gray'

    return (
      <li key={category.name} className={styles.btnlist_li}>
        {isActive ? (
          <span className={`${styles.btnlist_a} ${isActive ? styles.btnlist_active : ''}`}>{category.name}</span>
        ) : (
          <Link href={category.link} passHref>
            <a
              href={category.link}
              className={`${styles.btnlist_a} ${isGray ? styles.gray : ''}`}
              style={isActive ? isDisabled : {}}
            >
              {category.name}
            </a>
          </Link>
        )}
      </li>
    )
  }

  return (
    <ul className={styles.searchlist}>
      <li className={styles.searchlist_ul}>
        <div className={styles.searchhead}>サービスから探す</div>
        {categoryGroups.map((group, index) => (
          <ul className={styles.btnlist} key={index}>
            {group.map(renderCategoryItem)}
          </ul>
        ))}
      </li>
      <li className={styles.searchlist_ul}>
        <div className={styles.searchhead}>業界から探す</div>
        <ul className={styles.btnlist}>{industryCategories.map(renderCategoryItem)}</ul>
      </li>
    </ul>
  )
}

export default SearchTagList
